import TestConfigContext from './test-config-context';
import { TestAttribute } from './components/TestAttribute';

const TestAttributesConfig = TestConfigContext.Provider;

export { TestAttributesConfig };
export default TestAttribute;
